import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import classNames from "classnames";

const styles = {
  button: {
    background: "#f5f5f5 !important",
    borderRadius: 3,
    border: 0,
    color: "rgba(0, 0, 0, 0.87)",
    height: "4.5rem"
  }
};

function SubmitButton(props) {
  return (
    <Button
      disabled={props.disabled}
      onClick={props.onClick}
      className={classNames({
        [props.classes.button]: true,
        [props.border]: true,
        mr1: true
      })}
    >
      {props.children}
    </Button>
  );
}

SubmitButton.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(SubmitButton);



// WEBPACK FOOTER //
// ./src/components/DefaultButton/index.js